import {
    VENDOR_PRO_UPDATE_REQUEST,
    VENDOR_PRO_UPDATE_SUCCESS,
    VENDOR_PRO_UPDATE_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

// export const VendorProAction = (data) => {
//     return function (dispatch) {
//       dispatch({
//         type: VENDOR_PRO_UPDATE_REQUEST,
//         payload: true,
//       });
//       let OPTION = {
//         url: `${process.env.REACT_APP_API_PATH}/ebench/update_vendor_v2`,
//         method: "PUT",
//         data: data, 
//         headers: {
//           "content-type": "application/json",
//         },
//       };
//       axios(OPTION)
//         .then((res) => {
//           dispatch(updateDashboardContentPre(res.data));
//           return res.data;
//           // window.location.href = "/vendor_dashboard";
//         })
//         .catch((error) => {
//           console.log("MMMMMMM",error);
//           toast.error(error?.response?.data?.status?.message)
//           dispatch({
//             type: VENDOR_PRO_UPDATE_FAIL,
//             payload: false,
//             error: error,
//             msg: "Failed to load the information",
//           });
//         });
//     };
//   };
  export const updateDashboardContentPre = (data) => {
    return {
      type: VENDOR_PRO_UPDATE_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };

export const VendorProAction = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: VENDOR_PRO_UPDATE_REQUEST,
        payload: true,
      });

      const OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/update_vendor_v2`,
        method: "PUT",
        data: data,
        headers: {
          "content-type": "application/json",
        },
      };

      axios(OPTION)
        .then((res) => {
          dispatch(updateDashboardContentPre(res.data));  // Dispatch success action here
          // toast.success("Updated Successfully!");
          resolve(res.data);  // Resolving the promise with response data
        })
        .catch((error) => {
          const errorMessage =
            error?.response?.data?.status?.message || "Something went wrong!";
          console.error("Error: ", error);
          toast.error(errorMessage);
          dispatch({
            type: VENDOR_PRO_UPDATE_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
          reject(error);  // Rejecting the promise with the error
        });
    });
  };
};
